import type { RefObject } from 'react'
import { useContext } from 'react'
import { useSlateStatic } from 'slate-react'

import { Popover } from '../../../../../Popover'
import { ToolbarContext } from '../../text/RichTextEditor'
import { getButton, isButtonFocused, unbutton } from '../../text/buttons'
import { handleInsertLinkCommon, useLinkDetailsEffect } from './LinkTooltip.utils'
import { useTooltipState } from './LinkTooltipContext'
import EditMode from './components/EditMode'
import ViewMode from './components/ViewMode'
import useTooltipManagement from '../../text/useTooltipManagement'

export default function LinkTooltipButton({
  editableRef: _onlyUsedToForceARerender,
}: {
  readonly editableRef?: RefObject<HTMLElement | null>
}) {
  const editor = useSlateStatic()
  const { linkTooltipState, linkTooltipDispatch, errorDispatch } = useTooltipState()
  const [{ isButtonLinkTooltipOpen: isOpen }, toolbarDispatch] = useContext(ToolbarContext)
  const lastSelection = editor.useLastSelection(editor)

  const [inputRef, virtualReferenceElement] = useTooltipManagement()

  useLinkDetailsEffect(
    editor,
    isOpen,
    linkTooltipState,
    linkTooltipDispatch,
    toolbarDispatch,
    isButtonFocused,
    getButton,
    'open_button_tooltip',
    'close_button_tooltip',
  )

  function handleInsertButton() {
    handleInsertLinkCommon(editor, lastSelection, linkTooltipState, linkTooltipDispatch, errorDispatch, true)
  }

  const virtualRef = {
    current: virtualReferenceElement,
  } as React.RefObject<HTMLElement>

  return (
    <Popover
      open={isOpen}
      virtualRef={virtualRef}
      side="bottom"
      className={'dali-plugin-link-tooltip'}
      usePortal
      avoidCollisions
      onMouseDown={(e) => {
        e.stopPropagation()
      }}
      onPointerDownOutside={() => {
        toolbarDispatch({ type: 'close_link_tooltip' })
      }}
      onOpenAutoFocus={(e) => {
        if (linkTooltipState.isViewMode) {
          e.preventDefault()
        }
      }}
    >
      {linkTooltipState.isViewMode ? (
        <ViewMode lastSelection={lastSelection} editor={editor} unlink={unbutton} />
      ) : (
        <EditMode inputRef={inputRef} handleInsert={handleInsertButton} />
      )}
    </Popover>
  )
}
